import AttachMoneyIcon from '@mui/icons-material/AttachMoney'
import NumbersIcon from '@mui/icons-material/Numbers'
import { Box, ToggleButton, ToggleButtonGroup } from '@mui/material'
import { MetricDisplayMode } from '@src/types/MerchantStatistic'
import type { MouseEvent } from 'react'
import { useTranslation } from 'react-i18next'

interface LoanActivityMetricsValueToggleProps {
  value: MetricDisplayMode
  onChange: (mode: MetricDisplayMode) => void
}

export const LoanActivityMetricsValueToggle = ({ value, onChange }: LoanActivityMetricsValueToggleProps) => {
  const { t } = useTranslation()

  const handleChange = (_: MouseEvent<HTMLElement>, newMode: MetricDisplayMode | null) => {
    if (newMode) onChange(newMode)
  }

  return (
    <Box>
      <ToggleButtonGroup value={value} exclusive onChange={handleChange} size="small">
        <ToggleButton value={MetricDisplayMode.Count} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <NumbersIcon fontSize="small" />
          {t('merchantStatistics.merchantLoanActivity.viewCount')}
        </ToggleButton>
        <ToggleButton value={MetricDisplayMode.Amount} sx={{ display: 'flex', alignItems: 'center', gap: 0.5 }}>
          <AttachMoneyIcon fontSize="small" />
          {t('merchantStatistics.merchantLoanActivity.viewAmount')}
        </ToggleButton>
      </ToggleButtonGroup>
    </Box>
  )
}
